import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class Localidad {
  static getById (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`localidad?r={"clave":{"codigo":"${id}"}}`)

    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static getByNombreAndPostal (nombrePostal) {
    const axios = getAxiosInstance()
    let [nombre, codigoPostal] = nombrePostal.split(' - ')
    codigoPostal = Number(codigoPostal.slice(1, -1))

    const promise = axios.get(`localidad_nombre_y_postal?r=` +
      `{"clave":{"nombre": "${nombre}","codigo_postal":"${codigoPostal}"}}`)

    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}

export default Localidad
